import React from 'react';

import appConfig from '../../../../config/appConfig';
import SignedImage from '../../../System/SignedImage';

const PauseModeImage = ({image}) => {
    const mediaData = appConfig.getCombinedPathAssetPath(image);

    if (!image) return null;

    return (
        <SignedImage
            imgClassName='w-full h-[264px] object-contain bg-center'
            mediaData={mediaData}
            isThumbnailAvailable
            signIfNull
        />
    );
};

export default PauseModeImage;
